"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

var MainMenuExport = /*#__PURE__*/function (_React$Component) {
  _inherits(MainMenuExport, _React$Component);

  function MainMenuExport(props) {
    var _this;

    _classCallCheck(this, MainMenuExport);

    _this = _possibleConstructorReturn(this, (MainMenuExport.__proto__ || Object.getPrototypeOf(MainMenuExport)).call(this, props));
    _this.state = {
      path: _this.props.location.path
    };
    _this.isActive = _this.isActive.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(MainMenuExport, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement("li", {
        className: "main-nav__item export"
      }, /*#__PURE__*/_react.default.createElement("a", {
        title: this.props.text,
        href: "/export-projects",
        className: 'main-nav__link ' + this.isActive('/export-projects')
      }, /*#__PURE__*/_react.default.createElement("i", {
        className: "icon-export"
      })));
    }
  }, {
    key: "isActive",
    value: function isActive(path) {
      return this.props.location.pathname === path ? 'is-active' : '';
    }
  }]);

  return MainMenuExport;
}(_react.default.Component);

MainMenuExport.propTypes = {
  location: _propTypes.default.shape({
    pathname: _propTypes.default.string,
    path: _propTypes.default.string
  }),
  text: _propTypes.default.string
};
var _default = MainMenuExport;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./client/components/main-menu/menu-entry-export.js
// module id = 711
// module chunks = 0